import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { isEmpty } from '@app/util/util';
import { ActivitiesValidateResponse } from '@activities/entities/activities-booking';
import { ProductOption } from '@activities/activities-results/entities/activities-results';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { AccordionType, AccordionSize } from '@design-system/components/templates/accordion/entities/accordion.types';

@Component({
  selector: 'app-activities-policies',
  templateUrl: './activities-policies.component.html',
  styleUrls: ['./activities-policies.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ActivitiesPoliciesComponent {

  @Input() validation: ActivitiesValidateResponse;
  @Input() titleClass: string;
  @Input() isUserHistory = false;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly accordionType = AccordionType.Card;
  public readonly accordionSize = AccordionSize.SM;

  constructor() { }

  get products(): ProductOption[] {
    return this.validation?.Products?.ProductsDetails?.filter(product => !isEmpty(product.CancellationPolicies)) ?? [];
  }

  get hasPolicies(): boolean {
    return !!this.products?.length;
  }

  public trackById(index: number): number {
    return index;
  }

}
